// We make a string version of this pattern in a format that Contentful can accept.
export const patternFcpId = /^[A-Z]{2}[0-9]{4}$/;
export const patternFcpIdString = '^[A-Z]{2}[0-9]{4}$';

export const minAge = 1;
export const maxAge = 22;
export const genderIds = ['Female', 'Male'] as const;

export const programRegionCodes = ['AF', 'AS', 'CA', 'SA'] as const;
export const programRegionLabels = {
  AF: 'Africa',
  AS: 'Asia',
  CA: 'Central America and Caribbean',
  SA: 'South America',
};

export const programCountriesByRegion = {
  AF: ['BF', 'ET', 'GH', 'KE', 'RW', 'TZ', 'TG', 'UG'],
  AS: ['BD', 'ID', 'PH', 'LK', 'TH'],
  CA: ['DO', 'SV', 'GT', 'HT', 'HN', 'MX', 'NI'],
  SA: ['BO', 'BR', 'CO', 'EC', 'PE'],
} as const;

export const programCountryIsoCodes = [
  'BD',
  'BF',
  'BO',
  'BR',
  'CO',
  'DO',
  'EC',
  'ET',
  'GH',
  'GT',
  'HT',
  'HN',
  'ID',
  'KE',
  'LK',
  'MX',
  'PE',
  'PH',
  'RW',
  'SV',
  'TG',
  'TH',
  'TZ',
  'UG',
] as const;

export const limitedCountryIsoCodes = ['KH', 'MM', 'MW', 'NI', 'ZM'] as const;

export const programCountryLabels = {
  BD: 'Bangladesh',
  BF: 'Burkina Faso',
  BO: 'Bolivia',
  BR: 'Brazil',
  CO: 'Colombia',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  ET: 'Ethiopia',
  GH: 'Ghana',
  GT: 'Guatemala',
  HN: 'Honduras',
  HT: 'Haiti',
  ID: 'Indonesia',
  KE: 'Kenya',
  KH: 'Cambodia',
  LK: 'Sri Lanka',
  MM: 'Myanmar',
  MW: 'Malawi',
  MX: 'Mexico',
  NI: 'Nicaragua',
  PE: 'Peru',
  PH: 'Philippines',
  RW: 'Rwanda',
  SV: 'El Salvador',
  TH: 'Thailand',
  TZ: 'Tanzania',
  TG: 'Togo',
  UG: 'Uganda',
  ZM: 'Zambia',
};

export const countryIsoToRegionIso = (
  countryIso?: string,
): string | undefined => {
  if (!countryIso) {
    return;
  }
  const regionEntry = Object.entries(programCountriesByRegion).find(
    ([, countries]) => (countries as readonly string[]).includes(countryIso),
  );
  return regionEntry ? regionEntry[0] : undefined;
};
